"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageThreadType = exports.IndividualType = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["USER_MESSAGE"] = "USER_MESSAGE";
    MessageType["AI_MESSAGE"] = "AI_MESSAGE";
    MessageType["NEW_THREAD"] = "NEW_THREAD";
    MessageType["TOOL_CALL"] = "TOOL_CALL";
    MessageType["TOOL_RESULT"] = "TOOL_RESULT";
})(MessageType || (exports.MessageType = MessageType = {}));
var IndividualType;
(function (IndividualType) {
    IndividualType["USER"] = "USER";
    IndividualType["EMPLOYEE"] = "EMPLOYEE";
})(IndividualType || (exports.IndividualType = IndividualType = {}));
var MessageThreadType;
(function (MessageThreadType) {
    MessageThreadType["PERSONA"] = "PERSONA";
    MessageThreadType["EMPLOYEE"] = "EMPLOYEE";
    MessageThreadType["NONE"] = "NONE";
})(MessageThreadType || (exports.MessageThreadType = MessageThreadType = {}));
